(function ($, Global) {
    var urlParams = new UrlParams();
    function AuthModel() {
        // Déclaration class objet
    }

    AuthModel.prototype.register = function (data, $form, callback) {
        var self = this;

        var paramlnkpmc = urlParams.getParam('lnkpmc');
        var categoryPage = $('meta[name="CategoryPage"]').attr('content');

        if (data['CategoriePage'] == null) data['CategoriePage'] = categoryPage;

        if (paramlnkpmc !== null) data['lnkpmc'] = paramlnkpmc;

		$.ajaxPost('/ajax/login/create', data)
			.done(function (result) {
                self.handleFormResult(result, $form, callback)
			})
	}

    AuthModel.prototype.login = function (data, $form, callback) {
        var self = this;

		$.ajaxPost('/ajax/login/login', data)
			.done(function (result) {
				if (result.isSuccess) {
                    Global.scrollTo(0, 0)
                    self.handleFormResult(result, $form, callback)
				} else {
                    self.handleFormResult(result, $form, null)
				}				
			})
	}

	AuthModel.prototype.logout = function () {
		$.ajaxPost('/ajax/login/logout')
			.done(function (result) {
                var ssoModel = new SsoModel();
                ssoModel.logout();
			});
	}

    AuthModel.prototype.resetMdp = function (data, $form, callback) {
        var self = this;

		$.ajaxPost('/ajax/password/reset', data)
			.done(function (result) {
                self.handleFormResult(result, $form, callback)
			})
	}

    AuthModel.prototype.forgetMdp = function (data, $form, callback) {
        var self = this;

		$.ajaxPost('/ajax/password/forget', data)
			.done(function (result) {
                self.handleFormResult(result, $form, callback)
			})
	}

    AuthModel.prototype.handleFormResult = function (result, form, callback) {
        Global.ajaxCallback({
            results: result,
            form: form,
            success: callback
        })
    }

	Global.AuthModel = AuthModel;
}(jQuery, window));